import request from '@/utils/request.js';

// 账号密码登录
export const AccountLogin = function(data) {
	return request.post("/auth/account-login", data);
}
// 手机号验证码登录
export const MobileLogin = function(data) {
	return request.post("/auth/mobile-login", data);
}
export const EmailLogin = function(data) {
	return request.post("/auth/email-login", data);
}
export const GoogleLogin = function(data) {
	return request.post("/auth/google-login", data);
}

export const LoginByOpenid = function(data) {
	return request.post("/auth/openid-login", data);
}
//账号注册
export const Register = function(data) {
	return request.post("/account/register", data);
}
export const GetWechatPublicQrcode = function(data) {
	return request.get("/util/get-wechat-qrcode", data);
}
export const QueryOpenId = function(data) {
	return request.get("/util/query-openid", data);
}
export const QueryWechat = function(data) {
	return request.post("/util/query-wechat", data);
}

// 登陆账号信息
export const Profile = function(data) {
	return request.get("/account/profile", data);
}
export const ProfileNoAuth = function(data) {
	return request.get("/account/profile-public", data);
}
// 重置登录密码
export const ResetPassword = function(data) {
	return request.post("/auth/reset-password", data);
}
// 保存个人资料
export const SaveProfile = function(data) {
	return request.post("/account/save-profile", data);
}
// 修改密码
export const RevisePassword = function(data) {
	return request.post("/account/revise-password", data);
}

// 地址管理
export const GetRegionList = function(data) {
	return request.get("/util/regionList", data);
}
export const AddressList = function(data) {
	return request.get("/address/list", data);
}
export const GetAddress = function(data) {
	return request.get("/address/get", data);
}
export const SaveAddress = function(data) {
	return request.post("/address/save", data);
}
export const DeleteAddress = function(data) {
	return request.post("/address/delete", data);
}
export const SetDefaultAddress = function(data) {
	return request.post("/address/set-default", data);
}

// 款式草稿相关
export const GetDraft = function(data) {
	return request.get("/draft/get", data);
}
export const GetDraftByUUID = function(data) {
	return request.get("/draft/getByUUID", data);
}
export const SaveDraft = function(data) {
	return request.post("/draft/save", data);
}
export const DraftList = function(data) {
	return request.get("/draft/list", data);
}
export const DeleteDraft = function(data) {
	return request.post("/draft/delete", data);
}
export const updateImgList = function(data){
	return request.post('/draft/updateImgList',data)
}

// 设计相关
export const ProductCategoryList = function(data) {
	return request.get("/util/product_category", data);
}
export const GetDesign = function(data) {
	return request.get("/design/get", data);
}
export const GetDesignByUUID = function(data) {
	return request.get("/design/getByUUID", data);
}
export const SaveDesign = function(data) {
	return request.post("/design/save", data);
}
export const DesignList = function(data) {
	return request.get("/design/list", data);
}
export const DesignCount = function(data) {
	return request.get("/design/count", data);
}
export const DeleteDesign = function(data) {
	return request.post("/design/delete", data);
}
export const CopyDesignToDraft = function(data) {
	return request.post("/design/copy", data);
}
export const PatternSetting = function(data) {
	return request.get("/pattern/setting", data);
}
export const PatternCategoryList = function(data) {
	return request.get("/pattern/category", data);
}
export const PatternLabelList = function(data) {
	return request.get("/pattern/label", data);
}
export const PatternList = function(data) {
	return request.get("/pattern/list", data);
}
export const FabricCategoryList = function(data) {
	return request.get("/fabric/category", data);
}
export const FabricLabelList = function(data) {
	return request.get("/fabric/label", data);
}
export const FabricList = function(data) {
	return request.get("/fabric/lists", data);
}
export const GetFabric = function (data) {
	return request.get("/fabric/get", data);
}

export const AccessoryCategoryList = function(data) {
	return request.get("/accessory/category", data);
}
export const AccessoryLabelList = function(data) {
	return request.get("/accessory/label", data);
}
export const AccessoryList = function(data) {
	return request.get("/accessory/lists", data);
}
export const GetAccessory = function(data) {
	return request.get("/accessory/get", data);
}
// 获取印绣花工艺
export const GetYXTech = function (data) {
	return request.get("/tech_library/lists", data);
}
export const GetSpecialTech = function (data) {
	return request.get("/tech_library/special_list", data);
}


//发送验证码
export const SendSms = function(data) {
	return request.post("/util/sms", data);
}
// 验证短信验证码
export const CheckSms = function(data) {
	return request.post("/util/check-sms", data);
}
export const CheckCode = function(data) {
	return request.post("/util/check-code", data);
}
//发送验证码
export const SendEmail = function(data) {
	return request.post("/util/email", data);
}
// 验证短信验证码
export const CheckEmail = function(data) {
	return request.post("/util/check-email", data);
}


// 商品相关
export const SaveProduct = function(data) {
	return request.post("/product/save", data);
}
export const GetProduct = function(data) {
	return request.get("/product/get", data);
}
export const ProductList = function(data) {
	return request.get("/product/list", data);
}
export const UserProductCategoryList = function(data) {
	return request.get("/product/category", data);
}

export const ProductUnsale = function(data){
	return request.post('/product/unsale',data)
}

export const ProductOnsale = function(data){
	return request.post('/product/onsale',data);
}

export const ProductDelete = function(data){
	return request.post('/product/delete',data);
}

export const ProductCount = function(data){
	return request.get('/product/count',data)
}

// 订单相关
export const PoColor = function (data) {
	return request.get("/util/pocolor", data);
}
export const CreateOrder = function(data) {
	return request.post("/order/create", data);
}
export const OrderList = function(data) {
	return request.get("/order/list", data);
}
export const OrderCount = function(data) {
	return request.get("/order/count", data);
}
export const OrderDetail = function(data) {
	return request.get("/order/detail", data);
}
export const CheckoutOrder = function(data) {
	return request.post("/order/checkout", data);
}
export const PayOrder = function(data) {
	return request.post("/order/pay", data);
}
export const MakeupOrder = function(data) {
	return request.post("/order/makeup", data);
}
export const PayExecute = function(data) {
	return request.post("/order/paypal-execute", data);
}
export const GetOrderDesign = function(data) {
	return request.get("/order/get-design", data);
}
export const UpdateOrderDesign = function(data) {
	return request.post("/order/save-design", data);
}
export const SendFabric = function(data) {
	return request.post("/order/send-fabric", data);
}
export const CheckPayStatus = function (data) {
	return request.get("/pay/status", data);
}
export const ConfirmOrder = function(data) {
	return request.post("/order/confirm", data);
}
export const CancelOrder = function(data) {
	return request.post("/order/cancel", data);
}
export const GetOrderByPoNo = function(data) {
	return request.get("/order/detail-by-po", data);
}
export const GetOrderByCapture = function (data) {
	return request.get("/order/detail-by-capture", data);
};

//>首页
export const GetBannerList = function(data){
	return request.get('/banner/list',data)
}

//>帖子分类
export const GetCategoryList = function(data){
	return request.get('/category/list',data)
}


//>资讯
export const GetNewsCateList = function(data){
	return request.get('/info/sub_menu',data)
}

//获取PC配置
export const getSetting = function (data) {
	return request.get("/util/setting", data);
}


//>搜索结果
export const SearchResult = function(data){
	return request.post('/search/list',data);
}


//阿里云OSS
export const getOssToken  = function(data) {
	return request.get("/util/get-oss-token", data);
}

// 文件后端上传
export const uploadFile = async function(file, dir, options = {}) {
	let data = {dir, file}
	let newParams = new FormData;
	for (let i in data) {
		newParams.append(i, data[i])
	}
	options = {
		...options,
		headers: {
			'Content-Type': 'multipart/form-data',
		}
	}

	return await request.post('/util/upload-image', newParams, options)
}

